module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.13/frontend/_next/static/images/router-dcec14c67f4500b3640d6bbdbc503b63.png";